<side-panel-header
  [displayText]="resourcesLabel || 'Resources'"
  class="Resources__Header"
></side-panel-header>
@if (useCustom) {
  <ng-content></ng-content>
} @else {
  @for (attribute of attributeList; track attribute) {
    <model-attribute
      [config]="attribute"
      [context]="attributeListContext"
      (linkClicked)="handleResourceClicked($event)"
    ></model-attribute>
  }
}
